import React from 'react';
import BaseFileIcon from '../BaseFileIcon';

const DocIcon = ({ color = '#1d4998', text = 'DOC' }) => (
  <BaseFileIcon color={color} text={text} />
);

export default DocIcon;
